module.exports = __webpack_public_path__ + "static/media/naked-news-premium-snapchat-f726a45f.137982c8.png";